import React, { FC } from 'react';

import { GenInternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';

import { TypeMyAccountPageTranslations } from '@/utils/translations/types/TypeMyAccountPageTranslations';
import { getLocaleDomain } from '@/utils/helpers';
import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
} from '@/utils/rudderstack';

export type ReadingSkillSetTileProps = {
  t: TypeMyAccountPageTranslations;
  tile: TypeAccountNavTileFields;
  hasSkillSets: boolean;
  locale?: string;
};

const ReadingSkillSetTile: FC<ReadingSkillSetTileProps> = ({
  t,
  tile,
  locale,
  hasSkillSets,
}) => {
  if (!hasSkillSets) return null;

  const baseUrl = getLocaleDomain(locale);
  const rssPath = '/account/reading-skill-set';
  const rssLink = `${baseUrl}${rssPath}`;

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: rssLink,
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.READING_SKILL_SET_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      description={tile.description}
      titleDecorator={
        <>
          <GenInternalLink
            href={rssPath}
            cta={t.viewCta}
            onClick={sendItemClickedEvent}
          />
        </>
      }
    />
  );
};

export default React.memo(ReadingSkillSetTile);
